import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GridAutocompleteEditCell } from './GridAutocompleteEditCell';
import { selectFacilityDetail } from '@AMIEWEB/Facility/FacilityStore/Facility.selector';
import { FacilityResponse } from 'app/models/Facility/FacilityDetails';
import { selectSkillsetLookupData } from 'store/redux-store/facility-preferences/selectors';
export const GridDisciplineWrapper = props => {
  const { disciplines, specialties, subSpecialties, specialtyByDiscipline } = useSelector(selectSkillsetLookupData);
  const facilityDetail: FacilityResponse = useSelector(selectFacilityDetail);
  const [options, setOptions] = React.useState(disciplines);

  useEffect(() => {
    if (facilityDetail && disciplines) {
      setOptions(disciplines);
    }
  }, [facilityDetail, disciplines]);
  return <GridAutocompleteEditCell {...props} options={options} />;
};
